export const EVENTS = {
  CUSTOM_VIEW_CART: {
    name: "custom_view_cart",
    hasEcommerce: true,
    destinations: ["DataLayer"],
    requiredParams: [
      "brand",
      "region",
      "line_items",
      "currency",
      "value",
      "total_discount",
      "subtotal",
      "items",
    ],
  },

  ADD_TO_WISHLIST: {
    name: "add_to_wishlist",
    hasEcommerce: true,
    destinations: ["DataLayer"],
    requiredParams: [
      "brand",
      "region",
      "line_items",
      "currency",
      "value",
      "items",
    ],
  },

  ADD_TO_CART: {
    name: "add_to_cart",
    hasEcommerce: true,
    destinations: ["DataLayer"],
    requiredParams: [
      "brand",
      "region",
      "line_items",
      "currency",
      "value",
      "items",
    ],
  },

  REMOVE_FROM_CART: {
    name: "remove_from_cart",
    hasEcommerce: true,
    destinations: ["DataLayer"],
    requiredParams: [
      "brand",
      "region",
      "line_items",
      "currency",
      "value",
      "items",
    ],
  },

  ADD_COUPON: {
    name: "add_coupon",
    hasEcommerce: true,
    destinations: ["DataLayer"],
    requiredParams: [
      "brand",
      "region",
      "coupon",
      "coupon_message",
      "seller_cod_name",
    ],
  },

  SEARCH: {
    name: "search",
    hasEcommerce: false,
    destinations: ["DataLayer"],
    requiredParams: ["brand", "search_term", "search_found", "search_quantity"],
  },

  SEARCH_ZIPCODE: {
    name: 'search_zipcode',
    hasEcommerce: false,
    destinations: ['DataLayer'],
    requiredParams: ['brand', 'region', 'shippings', 'zipcode', 'flag_pickup'],
  },

  VIEW_PROMOTION: {
    name: "view_promotion",
    hasEcommerce: true,
    destinations: ["DataLayer"],
    requiredParams: [
      "brand",
      "region",
      "currency",
      "promotion_name",
      "creative_slot",
      "creative_name",
      "items",
    ],
  },

  SELECT_PROMOTION: {
    name: "select_promotion",
    hasEcommerce: true,
    destinations: ["DataLayer"],
    requiredParams: [
      "brand",
      "region",
      "currency",
      "promotion_name",
      "creative_slot",
      "creative_name",
      "items",
    ],
  },

  SELECT_CONTENT: {
    name: "select_content",
    hasEcommerce: false,
    destinations: ["DataLayer"],
    requiredParams: ["brand", 'content_type'],
  },

  SELECT_ITEM: {
    name: "select_item",
    hasEcommerce: true,
    destinations: ["DataLayer"],
    requiredParams: ["brand", "region", "items", "line_items"],
  },

  VIEW_ITEM: {
    name: "view_item",
    hasEcommerce: true,
    destinations: ["DataLayer"],
    requiredParams: [
      "brand",
      "line_items",
      "currency",
      "value",
      "available_grid",
      "items",
    ],
  },

  CUSTOM_VIEW_ITEM: { // IO STORES
    name: "custom_view_item",
    hasEcommerce: true,
    destinations: ["DataLayer"],
    requiredParams: [
      "brand",
      "line_items",
      "currency",
      "value",
      "available_grid",
      "items",
    ],
  },

  VIEW_ITEM_LIST: {
    name: "view_item_list",
    hasEcommerce: true,
    destinations: ["DataLayer"],
    requiredParams: ["region", "brand", "line_items", "items"],
  },

  BEGIN_CHECKOUT: {
    name: "begin_checkout",
    hasEcommerce: true,
    destinations: ["DataLayer"],
    requiredParams: ["brand", "line_items", "currency", "value", "total_discount", "subtotal", "items"],
  },

  CUSTOM_BEGIN_CHECKOUT: {
    name: "custom_begin_checkout",
    hasEcommerce: true,
    destinations: ["DataLayer"],
    requiredParams: ["brand", "line_items", "currency", "value", "total_discount", "subtotal", "items"],
  },

  AUTH_ACTION: {
    name: "auth_action",
    hasEcommerce: false,
    requiredParams: ["region"],
  },

  ADD_PERSONAL_INFO: {
    name: "add_personal_info",
    hasEcommerce: true,
    destinations: ["DataLayer"],
    requiredParams: ["brand", "pre_filled", "line_items", "currency", "value", "total_discount", "subtotal"],
  },

  CUSTOM_ADD_SHIPPING_INFO: {
    name: "add_shipping_info",
    hasEcommerce: true,
    destinations: ["DataLayer"],
    requiredParams: [
      "brand",
      "pre_filled",
      "shipping",
      "shipping_tier",
      "line_items",
      "currency",
      "value",
      "total_discount",
      "subtotal",
      "items"
    ],
  },

  CUSTOM_ADD_PAYMENT_INFO: {
    name: "add_payment_info",
    hasEcommerce: true,
    destinations: ["DataLayer"],
    requiredParams: [
      "brand",
      "pre_filled",
      "line_items",
      "currency",
      "value",
      "total_discount",
      "payment_type",
      "subtotal",
      "items"
    ],
  },

  ORDER_REVIEWED: {
    name: "order_reviewed",
    hasEcommerce: true,
    destinations: ["DataLayer"],
    requiredParams: ["brand", "line_items", "currency", "value", "total_discount", "subtotal", "payment_type"],
  },

  PURCHASE: {
    name: "purchase",
    hasEcommerce: true,
    destinations: ["DataLayer"],
    requiredParams: [
      'brand',
      'shipping_tier',
      'line_items',
      'currency',
      'value',
      'shipping',
      'transaction_id',
      'total_discount',
      'payment_type',
      'seller_cod_name',
      'subtotal',
      'coupon',
      'items'
    ],
  },

  CUSTOM_PURCHASE: {
    name: "custom_purchase",
    hasEcommerce: true,
    destinations: ["DataLayer"],
    requiredParams: [
      'brand',
      'shipping_tier',
      'line_items',
      'currency',
      'value',
      'shipping',
      'transaction_id',
      'total_discount',
      'payment_type',
      'seller_cod_name',
      'subtotal',
      'coupon',
      'items'
    ],
  },

  CUSTOM_USER_INFO: {
    name: 'custom_user_info',
    hasEcommerce: false,
    destinations: ["DataLayer"],
    requiredParams: ['user_info']
  },

  NOTIFY_ME: {
    name: 'notify_me',
    hasEcommerce: false,
    destinations: ["DataLayer"],
    requiredParams: ['brand', 'line_items', 'size', 'item_ref']
  }
};
